<template>
	<AiChat ref="aiChat" :open="visible"  :quote="quote" @on-close="cancelHandler" @on-insert="onInsert">
    <template v-slot:title>
      <span>{{curKnowledge && curKnowledge.id ? '编辑知识库' : '增加知识库'}}</span>
    </template>
		<div class="qu-container">
			<div class="top-style">
				<RadioGroup v-model="formData.type" type="button">
					<Radio label="normal">常规问题</Radio>
					<Radio label="bussiness">业务问题</Radio>
				</RadioGroup>
			</div>
			<Form class="form-content" :model="formData" ref="form" label-position='left'>
				<FormItem label="标题" prop="name" :rules="{required: true, message: '标题不能为空', trigger: 'blur'}">
					<Input v-model="formData.name" style="width: 300px" placeholder="" />
				</FormItem>
        <form-item-share-keyword v-if="visible" :formItemProps="{prop: 'ref'}" v-model="formData.ref"/>
				<form-item-keyword
					v-model="formData.sentences"
					:formItemProps="{ prop: 'sentences', rules: keywordRules }"
          @open-ai="() => {
            quote = {
              type: 'aichat.hint',
              name: formData.name,
              workId: 'GENERALIZED_KEYWORDS',
              variables: {
                matching_content: formData.name,
                keywords: (formData.sentences || []).join(',')
              }
            }
						insert.type = 'sentences'
						this.$refs.aiChat.sendMessage('泛化')
          }"
				/>
        <form-item-conditions v-model="formData.conditions"/>
				<div style="margin: 20px 0">
					<p>A(机器人标准答案):</p>
					<div>
						<Tabs value="" @on-click="(index) => {
							voiceTabIndex = index
						}">
							<TabPane v-for="(response, index) in formData.responses" :name="`${index}`" :key="response.id || index" :label="responseLabel(index)">
								<div class="response-container">
									<div>
										<upload-audio
											@uploadSuccess="(file) => response.voice = file"
											:filepath="response.voice"
											@delect="response.voice = ''"
										/>
									</div>
									<Input type="textarea" :rows="3" v-model="response.text"  placeholder="" />
									<FormItem label="动作:" style="margin-top: 10px;">
										<Select v-model="response.action" placeholder="等待客户回复" clearable style="width: 100px; margin-right: 15px" transfer>
											<Option value="jump">跳转</Option>
											<Option value="hangup">挂机</Option>
											<Option value="transfer">转接</Option>
											<Option value="return">返回原节点</Option>
										</Select>
										<form-item-jump-action v-if="response.action === 'jump'" v-model="response.action_data" />
									</FormItem>
								</div>
							</TabPane>
							<Button @click="addResponse" size="small" slot="extra">增加回答</Button>
							<Button @click="() => {
								quote = {
									type: 'aichat.hint',
									name: `${formData.name}-语音${~~voiceTabIndex + 1}`,
									workId: 'OPTIMIZE_CALL_SCRIPT',
									hint: `节点名称:${formData.name}\n节点文本:${formData.responses && formData.responses[voiceTabIndex] && formData.responses[voiceTabIndex].text}`
								}
								insert.type = 'responses'
								this.$refs.aiChat.sendMessage('优化')
							}" size="small" slot="extra" type="success">文案优化</Button>
						</Tabs>
					</div>
				</div>
        <!-- <FormItem label="回答播报设置" style="margin-bottom: 0;">
          <i-switch v-model="formData.is_replay_threshold"/>
          <Tooltip max-width="300" content="若话术播报中途跳出节点后再返回，系统将判断跳转前的播报时长：若已超过设定值，则不再重复播报节点话术，而是静默等待客户回复，并依据回复内容决定后续流走向向。" placement="top">
            <Icon style="margin-left: 5px;" type="ios-help-circle-outline" />
          </Tooltip>
        </FormItem> -->
        <!-- <div v-if="formData.is_replay_threshold" style="line-height: 1.8; background: #f5f7fa; padding: 12px 16px; border-radius: 4px; margin-bottom: 24px;">
          <span>当原回答音频播报时长大于等于</span>
          <InputNumber
            v-model="formData.replay_threshold"
            :min="0"
            style="width: 70px; margin: 0 5px;"
            placeholder="0"
          />
          <span>ms时，若该知识库再次被触发则不再播报该音频。若未到达配置条件，且节点存在多个语音，则循环播放。</span>
        </div> -->
				<!-- 设置评级 -->
				<form-item-rating v-model="formData.rate" />
				<form-item-can-break v-model="formData.can_break" />
				<FormItem label="前">
					<InputNumber v-model="formData.break_delay" :min="0" /><span style="margin-left: 5px">ms不打断</span>
				</FormItem>
				<FormItem label="协同提醒">
          <div>
            <i-switch v-model="formData.hmc_remind"/>
            <span style="margin-left: 15px;" v-if="formData.hmc_remind">
              <SkillSelect v-model="formData.hmc_skill_id" v-if="access.userSkill" />
            </span>
          </div>
        </FormItem>
				<FormItem label="说完转接">
					<i-switch v-model="formData.hmc_after_play"/>
				</FormItem>
				<FormItem label="自定义标签">
					<Select
						v-model="formData.tag"
						filterable
						multiple
						allow-create
						placeholder="请输入，按回车添加"
					>
						<Option
							v-for="item in tagList"
							:value="item"
							:key="item"
							>{{ item }}</Option
						>
					</Select>
				</FormItem>
				<div class="vars-header">
					<span>变量操作</span>
					<Button @click="addVar" shape="circle" type="warning">添加操作</Button>
				</div>
				<div v-for="(item, index) in formData.vars" :key="item.id" class="var-line">
					<var-form-item  v-model="formData.vars[index]" class="var-form"/>
					<Icon
						class="var-del-icon"
						color="#ed4014"
						type="ios-trash-outline"
						@click="delVar(index)"
					/>
				</div>
			</Form>
			<div class="btn">
				<Button style="margin-right: 20px" color="#547ed1" @click="cancelHandler">取消</Button>
				<Button type="primary" style="margin-right: 20px" color="#547ed1" @click="submit">确定</Button>
			</div>
		</div>
	</AiChat>
</template>
<script>
import { mapState } from 'vuex';
import VarFormItem from '../../../components/VarFormItem.vue';
import cloneDeep from 'lodash/cloneDeep'
import FormItemCanBreak from '../../../components/FormItemCanBreak.vue';
import FormItemKeyword from '../../../components/FormItemKeyword.vue';
import FormItemRating from '../../../components/FormItemRating.vue';
import UploadAudio from '../../../components/uploadAudio.vue';
import FormItemJumpAction from '../../../components/FormItemJumpAction.vue';
import { addNodeId } from '@/utils/nodeIdPool';
import FormItemConditions from '../../../components/FormItemConditions.vue';
import FormItemShareKeyword from '../../../components/FormItemShareKeyword.vue';
import SkillSelect from '../../../components/SkillSelect.vue';
import AiChat from '@/views/aiChat/index'

export default {
  components: {
		VarFormItem,
		FormItemCanBreak,
		FormItemKeyword,
		FormItemRating,
		UploadAudio,
		FormItemJumpAction,
		FormItemConditions,
		FormItemShareKeyword,
		SkillSelect,
    AiChat,
	},
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    curKnowledge: {
      type: Object,
    }
  },
	data() {
    const validateSentences = (rule, value, callback) => {
      if (value.length === 0 && !this.formData.ref.id) {
        callback(new Error('关键词不能为空'));
      } else {
        callback();
      }
    }
		return {
			formData: {
				type: 'normal',
				name: '',
  			key_words: '', // 这个没用了，暂时留着
				sentences: [],
        ref: {
          id: '',
          isPriority: true,
        },
				conditions: [],
				responses: [{ text: '', voice: '', id: addNodeId('V'), action: '', action_data: '' }],
				tag: [],
				can_break: false,
  			break_delay: 0,
				hmc_remind: false,
				hmc_skill_id: '',
        hmc_after_play: false,
				rate: '',
				vars: [],
				is_replay_threshold: false,
				replay_threshold: 0,
      },
			keywordRules: { validator: validateSentences },
      quote: null,
			insert: {
				type: '',
			},
			voiceTabIndex: 0,
		}
	},
	computed: {
    ...mapState('flow', [
			'flows'
    ]),
		tagList() {
			return this.formData.tag?.length > 0 ? this.formData.tag : [''];
		},
		...mapState('user', ['access']),
	},
	watch: {
		curKnowledge(val) {
			if (!val) return
      const { ref_id, is_ref_priority, name, rate, sentences, responses, action, action_data, ...formData } = cloneDeep(val)
      this.formData = {
				...this.formData,
        ...formData,
				name: `${name}`,
				sentences: sentences,
				rate: `${rate}`,
        tag: val.tag?.split(' '),
				ref: { id: ref_id, isPriority: is_ref_priority },
				responses: responses && responses.map(item => ({
					...item,
					text: `${item.text}`,
					action: item.action || action || '',
					action_data: item.action_data || action_data || ''
				})) || [],
        is_replay_threshold: !!val.replay_threshold
      }
		}
	},
	methods: {
		// 添加回答
		addResponse() {
			this.formData.responses.push({ text: '', voice: '', id: addNodeId('V'), action: '', action_data: '' })
		},
		// 删除回答
		delResponse(index) {
			this.formData.responses.splice(index, 1);
			// 如果是最后一个，则新加一下
			if (this.formData.responses.length === 0) {
				this.addResponse();
			}
		},
		responseLabel(index) {
			return (h) => h(
				'div', [
					h('span', `回答${index + 1}`),
					h('Icon', {
						style: 'margin-left: 5px; margin-right: 0',
						props: {
							type: 'md-close'
						},
						on: {
							click: () => {
								this.delResponse(index)
							}
						}
					})
				]
			)
		},
		// 添加变量
		addVar() {
			this.formData.vars.push({ name: '', op: '', value: '' });
		},
		// 删除变量
		delVar(index) {
			this.formData.vars.splice(index, 1);
		},
    submit() {
      this.$refs.form.validate((valid) => {
				if (!valid) return;
        let { ref, is_replay_threshold, ...formData } = this.formData
        formData = {
          ...formData,
          ref_id: ref.id,
          is_ref_priority: true,
          // is_ref_priority: ref.isPriority,
					rate: ~~this.formData.rate,
          tag: this.formData.tag?.join(' '),
          hmc_skill_id: this.formData.hmc_remind ? this.formData.hmc_skill_id : '',
          replay_threshold: is_replay_threshold ? this.formData.replay_threshold : 0,
        }
				// 处理每个response的action_data
				formData.responses = formData.responses
					.filter(item => item.text || item.voice || item.action)
					.map(item => ({
						...item,
						action: item.action || '',
						action_data: item.action === 'jump' ? (item.action_data || '') : ''
					}))
				this.$emit('onSubmit', formData);
        this.cancelHandler();
      })
    },
		cancelHandler() {
      this.$refs.form.resetFields()
      this.formData = {
				type: 'normal',
				name: '',
  			key_words: '', // 这个没用了，暂时留着
				sentences: [],
        ref: {
          id: '',
          isPriority: true,
        },
				conditions: [],
				responses: [{ text: '', voice: '', id: addNodeId('V'), action: '', action_data: '' }],
				tag: [],
				can_break: false,
  			break_delay: 0,
				hmc_remind: false,
				hmc_skill_id: '',
        hmc_after_play: false,
				rate: '',
				vars: [],
				is_replay_threshold: false,
				replay_threshold: 0,
      }
      this.$emit('change', false)
      this.$emit('cancel');
			this.quote = null
			this.voiceTabIndex = 0
			this.insert = {
				type: '',
			}
		},
    onInsert(text) {
			if (this.insert.type === 'sentences') {
				const sentences = this.formData.sentences
				sentences.push(...text.split(/[,，]/))
				this.formData.sentences = [...new Set(sentences)]
			} else if (this.insert.type === 'responses' && this.formData.responses[this.voiceTabIndex]) {
				this.formData.responses[this.voiceTabIndex].text = text
			}
    },
	}
}
</script>
<style lang="scss" scoped>
.qu-container{
	padding: 10px;
	padding-bottom: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.top-style{
	text-align: center;
	padding-bottom: 20px
}
.form-content {
  overflow-y: auto;
  flex: 1;
}
.btn {
  width: 100%;
  background: #fff;
  padding: 10px 16px;
  text-align: right;
	border-top: 1px solid #e8e8e8;
}
.style1{
	color: #457ED1;
	padding-right: 20px;
}
.style2{
	color: #ff9c00;
}
.ivu-upload{
	display: inline-block;
}
.formgroup{
	padding: 10px 0;
}
.tip-style{
	color: #ff9600;
}
.branch-container{
	width: auto;
	background-color: #f3f3f3;
	min-height: 100px;
	padding: 20px;
}
.upload-style{
	vertical-align: super;padding-right: 10px;
	color: #457ED1;
	cursor: pointer;
}
.btn{
	text-align: right;
}
.vars-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}
.var-line {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.var-form {
	flex: 1;
}
.var-del-icon {
	margin-left: 10px;
	font-size: 16px;
}
.response-container {
	background-color: #f8f9fa;
	padding: 15px;
	border-radius: 6px;
	border: 1px solid #e8e8e8;
}
</style>